import React from 'react';
import { useSelector } from 'react-redux';
import 'src/style/createVehicleTracking.css';

const getUnitOfMeasurement = (item) => item?.unit_of_measurement?.name;

const formatValueWithUom = (value, item) => {
  const uom = getUnitOfMeasurement(item);
  const displayValue =
    value !== null && value !== undefined && value !== '' ? value : '-';

  return uom && displayValue !== '-' ? `${displayValue} ${uom}` : displayValue;
};

function DeliveryReviewListTab({ deliveryLineItem = [] }) {
  const authReducer = useSelector((state) => state.AuthReducer);
  const themeColor = authReducer?.userData?.tenant?.theme;

  return (
    <div className="duplicate-delivery-tab vertical-padding-10 horizontal-padding-10">
      <div className="div-flex-row div-space-between section-title div-align-center">
        <div className="text-xxl text-bold">Delivery List</div>
      </div>
      <div
        className={`po-table-wrapper delivery-table-fixed-container theme-scrollable-container-${themeColor}`}
      >
        <table>
          <thead className="outward-delivery-table-head">
            <tr>
              <th>Delivery Number</th>
              <th>Delivery Date</th>
              <th>Pack Type</th>
              <th>Pack Quantity</th>
              <th>Grade</th>
              <th>Gross Weight</th>
              <th>Product SAP Code</th>
              <th>Product Description</th>
              <th>Plant</th>
              <th>Net Weight</th>
              <th>Batch</th>
              <th>Sales Order Number</th>
            </tr>
          </thead>
          <tbody>
            {deliveryLineItem.length === 0 ? (
              <tr>
                <td
                  colSpan={12}
                  className="no-data-found-message border-bottom vertical-padding-10"
                >
                  <span className="text-sm">No Delivery Items Found</span>
                </td>
              </tr>
            ) : (
              deliveryLineItem.map((deliveryObj) => {
                const lineItems = deliveryObj.line_items?.length
                  ? deliveryObj.line_items
                  : [{}];
                const rowSpan = lineItems.length;

                return lineItems.map((item, itemIndex) => (
                  <tr
                    key={
                      item?.delivery_line_item_id ||
                      `${deliveryObj.delivery_id}-${itemIndex}`
                    }
                  >
                    {itemIndex === 0 && (
                      <>
                        <td rowSpan={rowSpan}>
                          {deliveryObj?.sap_code ?? '-'}
                        </td>
                        <td rowSpan={rowSpan}>
                          {deliveryObj?.delivery_date ?? '-'}
                        </td>
                        <td rowSpan={rowSpan}>
                          {deliveryObj?.pack_type ?? '-'}
                        </td>
                        <td rowSpan={rowSpan}>
                          {deliveryObj?.pack_quantity ?? '-'}
                        </td>
                        <td rowSpan={rowSpan}>{deliveryObj?.grade ?? '-'}</td>
                        <td rowSpan={rowSpan}>
                          {formatValueWithUom(deliveryObj?.weight, deliveryObj)}
                        </td>
                      </>
                    )}
                    <td>{item?.product?.product_sap_code ?? '-'}</td>
                    <td>
                      {item?.product_description ||
                        item?.product?.product_description ||
                        '-'}
                    </td>
                    <td>{item?.plant?.name ?? '-'}</td>
                    <td>{formatValueWithUom(item?.quantity, item)}</td>
                    <td>{item?.batch ?? '-'}</td>
                    {itemIndex === 0 && (
                      <td rowSpan={rowSpan}>
                        {deliveryObj?.sales_order_number ?? '-'}
                      </td>
                    )}
                  </tr>
                ));
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DeliveryReviewListTab;
